import { gql } from '@apollo/client';

const PRACTITIONER_QUALIFICATIONS = gql`
    query practitionerBadgesQualifications ($practitionerId: Int!) {
        practitionerProfileBadgesQualifications(profileId: $practitionerId) {
            qualificationName
            qualificationDate
        }
    }
`;
export default PRACTITIONER_QUALIFICATIONS;